import { render, staticRenderFns } from "./TransferirChat.vue?vue&type=template&id=e872cd0c"
import script from "./TransferirChat.vue?vue&type=script&lang=js"
export * from "./TransferirChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports